import React, { useState, useEffect, useRef }  from "react";
import "../styles/About.css"; // Create this new stylesheet
import hbsLogo from "../assets/hbs-logo.png"; // Importing image
import ilabLogo from "../assets/ilab-logo.png";
import apartmentSplash from "../assets/Boston_Building.jpeg"; // Import the image

function AboutUs() {
	
	const [scrolled, setScrolled] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (contentRef.current) {
                console.log("Scroll position:", contentRef.current.scrollTop);
                setScrolled(contentRef.current.scrollTop > 50);
            }
        };

        const contentElement = contentRef.current;
        if (contentElement) {
            contentElement.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (contentElement) {
                contentElement.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);

	
    return (
        <div className="about-container">
            <div className="about-content" ref={contentRef}>
				<div className = "align-box">
					<div className="Page-Content">
						<div className="about-text">
							<h1>Why MILO</h1>
						</div>

						<div className="about-text">
							<h2>For Tenants:</h2>
							<ul>
								<li><strong>Clarity & Confidence:</strong> When you see an apartment on MILO, you know you qualify. Your rental profile does the heavy lifting so that you can focus on finding your perfect apartment.</li>
								<li><strong>Efficiency:</strong> Say goodbye to wasted time on listings that don’t match your financial profile. MILO streamlines your search and speeds up the rental process.</li>				
							</ul>

							<h2>For Landlords & Brokers:</h2>
							<ul>
								<li><strong>Quality Leads:</strong> Receive leads that meet your specific criteria, reducing time spent on unqualified prospects.</li>
								<li><strong>Seamless Management:</strong> Our platform automatically updates listings once a lease is signed, so you can focus on what matters—growing your business.</li>
								<li><strong>Data-Driven Insights:</strong> Today, we match based on proven metrics like credit scores and income. Tomorrow, we’ll leverage deeper transactional data to predict tenant success with near-perfect accuracy.</li>
							</ul>

						</div>
					</div>
				</div>
				
				<div className="about-cta">
					<a href="/waitlist" className="cta-button primary">Join the Waitlist</a>
					<a href="/contact/WhyMILO" className="cta-button secondary">Contact Us</a>
				</div>
            </div>
            <div className={`about-image ${scrolled ? "scrolled" : ""}`} style={{ backgroundImage: `url(${apartmentSplash})` }}></div>
        </div>
    );
}

export default AboutUs;
